import { SEARCH_PRODUCTS_WATCHER, SEARCH_PRODUCTS_SUCCESS, SEARCH_PRODUCTS_FAILED } from './constants';

const initialState = {
	isLoading: true,
	data: []
};

export default (state = initialState, action) => {
	switch (action.type) {
		case SEARCH_PRODUCTS_WATCHER:
			return {
				isLoading: true,
				data: []
			};
		case SEARCH_PRODUCTS_SUCCESS:
			return {
				isLoading: false,
				data: action.payload
			};
		case SEARCH_PRODUCTS_FAILED:
			return {
				isLoading: false,
				data: action.payload
			};
		default:
			return state;
	}
};
